import { z } from 'zod';

export const CertificationStatus = {
  ACTIVE: 'active',
  EXPIRED: 'expired',
  PENDING: 'pending',
  EXPIRING_SOON: 'expiring_soon',
} as const;

export type CertificationStatus = (typeof CertificationStatus)[keyof typeof CertificationStatus];

export const CertificationSchema = z.object({
  id: z.string(),
  name: z.string(),
  issuingBody: z.string(),
  certificateNumber: z.string(),
  issueDate: z.string(),
  expiryDate: z.string(),
  status: z.enum(['active', 'expired', 'pending', 'expiring_soon']),
  documentUrl: z.string().optional(),
  categories: z.array(z.string()),
});

export type Certification = z.infer<typeof CertificationSchema>;
